<template>

    <div class="ApplicantDetails">
		<div class="">
			<div class="">
			<div rounded class="q-pa-sm">
				<!-- <q-field :label='$t("Applicant-Detail.title")' readonly orientation="vertical"></q-field> -->
				<!-- <div class="text-bold">{{$t("Applicant-Detail.title")}}</div> -->
					<div class="row">	
							<div class="col-12 col-md-6">
								<!-- <q-select
								filled
									label="Salutation *"
									v-model="StoreStateAOD.PersonalInformation.Salutation"
									:options="StoreStateLookup.Salutation_LK"
									:readonly="$route.name==='Application Details'"
								/> -->
								<!-- <q-select outlined v-model="model" :options="options" label="Outlined">
									<template v-slot:prepend>
										<q-icon name="event" />
									</template>
								</q-select> -->
								<b>{{$t("Applicant-Detail.salutation")}}</b>
								<q-select
									outlined
									behavior="menu"
									v-model="StoreStateAOD.PersonalInformation.Salutation"
									:options="StoreStateLookup.Salutation_LK"
									lazy-rulesss :rules="[val => !!val || '' + $t('common.fieldRequired') +' ' ]"  >
									<template v-slot:prepend>
										<q-icon name="fas fa-crown" size="20px" color="grey-4"/>
									</template>
								</q-select>
							</div>

							
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.fullname")}}</b>
								<q-input 
								v-model="StoreStateAOD.PersonalInformation.FullName" 
								outlined
								ref="FullName" 
								lazy-rulesss :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
								:readonly="$route.name==='AHAM Investment'" 
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-user" size="20px" color="grey-4"/>
									</template>
								</q-input>
							</div>
					</div>
					
					<div class="row">
							<div class="col-12 col-md-6">
									<b>{{$t("Applicant-Detail.idtype")}}</b>
									<br>
									<q-btn-toggle
										unelevated
									 	:readonly="$route.name =='AHAM Investment'"
										size="md"
										v-model="StoreStateAOD.PersonalInformation.IdType"
										toggle-color="teal-14"
										color="tertiary"
										text-color="grey"
										:options="StoreStateLookup.IdType_LK"
										class="d-btn-toggle"
										
									/>
							</div>
							
					
							<div class="col-12 col-md-6">
								<div v-if="StoreStateAOD.PersonalInformation.IdType==='NewIC'" >
								<b>{{$t("Applicant-Detail.newic")}}</b>
								<q-input
								outlined
								lazy-rulesss 
								:rules="[val => !!val ||'' + $t('common.fieldRequired') +' ']" 
								:readonly="$route.name =='AHAM Investment'"
								
								v-model="StoreStateAOD.PersonalInformation.NRIC" 
								
								>
									<template v-slot:prepend>
										<q-icon name="far fa-id-card" size="20px" color="grey-4"/>
									</template>
								</q-input>
								</div>
								
								<div v-else-if="StoreStateAOD.PersonalInformation.IdType==='OldID'" >
								<b>{{$t("Applicant-Detail.oldic")}}</b>
								<q-input
								outlined 
								lazy-rulesss 
								:rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
								:readonly="$route.name =='AHAM Investment'"
								
								v-model="StoreStateAOD.PersonalInformation.OldID" 
								:label='$t("Applicant-Detail.oldic")' 
								>
									<template v-slot:prepend>
										<q-icon name="far fa-id-card" size="20px" color="grey-4"/>
									</template>
								</q-input>
								</div>

							</div>

							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.dob")}}</b>
								<q-input 
								outlined
								v-model="StoreStateAOD.PersonalInformation.DateOfBirth" 
								lazy-rulesss :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"  
								
								:readonly="$route.name =='AHAM Investment'"
								>
									<template v-slot:prepend>
										<q-icon name="far fa-calendar-alt" size="20px" color="grey-4"/>
									</template>
								</q-input>
							</div>

							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.age")}}</b>
								<q-input 
								outlined
								v-model="StoreStateAOD.PersonalInformation.Age" 
								lazy-rulesss :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"  
								
								type="number"
								:readonly="$route.name =='AHAM Investment'"
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-birthday-cake" size="20px" color="grey-4"/>
									</template>
								</q-input>
							</div>
							
					
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.gender")}}</b>
								<br>
								<q-btn-toggle
								unelevated
								v-model="StoreStateAOD.PersonalInformation.Gender"
								toggle-color="teal-14"
								color="tertiary"
								text-color="grey"
								:rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
								:options="StoreStateLookup.Gender_LK"
								class="d-btn-toggle"
								
								/>
								<!-- :readonly="$route.name =='AHAM Investment'" -->
							</div>
					
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.race")}}</b>
								<q-select
									behavior="menu"
									outlined
									lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
									color="primary"
									v-model="StoreStateAOD.PersonalInformation.Race"
									:options="StoreStateLookup.Race_LK"
									:readonly="$route.name==='Application Details'"
									@input="PopulateHolderStatus()"
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-users" size="20px" color="grey-4"/>
									</template>
								</q-select>
								
							</div>

							<div class="col-12 col-md-6" v-if="StoreStateAOD.PersonalInformation.Race.value==='OT'">
								<b>{{$t("Applicant-Detail.raceOth")}}</b>
								<q-input 
									outlined
									v-model="StoreStateAOD.PersonalInformation.RaceOth" 
									
									lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
									:readonly="$route.name==='LandingPage'"
								/>
									<!-- <template v-slot:prepend>
										<q-icon name="far fa-calendar-alt" size="20px" color="grey-4"/>
									</template>
								</q-input> -->
							
							</div>

							

							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.holderstatus")}}</b>
								<q-select
									outlined
									lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
									color="primary"
									behavior="menu"
									v-model="StoreStateAOD.PersonalInformation.HolderStatus"
									:options="StoreStateLookup.HolderStatus_LK"
										:readonly="$route.name==='Application Details'"
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-street-view" size="20px" color="grey-4"/>
									</template>
								</q-select>
							</div>

							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.maritalstatus")}}</b>
								<q-select
									behavior="menu"
									outlined
									lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
									color="primary"
									v-model="StoreStateAOD.PersonalInformation.MaritalStatus"
									:options="StoreStateLookup.MaritalStatus_LK"
										:readonly="$route.name==='Application Details'"
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-user-friends" size="20px" color="grey-4"/>
									</template>
								</q-select>
							</div>
					
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.dependents")}}</b>
								<div style="border-radius: 0.5rem !important; height: 56px; border: 1px solid rgba(0,0,0,0.24); margin-bottom: 20px;">
									<q-toggle
									color="green-14"
									v-model="StoreStateAOD.PersonalInformation.IsDependents"
									:label="StoreStateAOD.PersonalInformation.IsDependents ? 'Yes':'No'"
									:readonly="$route.name==='Application Details'"
									style="margin: 8px !important;"
									/>
								</div>
							</div>
						
							<div class="col-12 col-md-6" v-if="StoreStateAOD.PersonalInformation.IsDependents===true">
								<div class="col-12 col-md-6">
									<b>{{$t("Applicant-Detail.dependentcount")}}</b>
									<q-input 
									outlined
									type="number" 
									min="1"
									v-model="StoreStateAOD.PersonalInformation.NoOfDependents" 
									
									lazy-rules :rules="[val => !!val & val !== 0 & val >= 0 || '' + $t('common.fieldRequired') +' ']" 
									:readonly="$route.name==='LandingPage'"
									>
										<template v-slot:prepend>
											<q-icon name="fas fa-child" size="20px" color="grey-4"/>
										</template>
									</q-input>
								</div>
							</div>
							
					</div>	
					
					<div class="row">
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.countrycode")}}</b>
								<q-select
									behavior="menu"
									outlined
									filter
									color="primary"
									lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"
									v-model="StoreStateAOD.ContactInformation.MobileNoCode"
									:options="StoreStateLookup.InternationalDialingCode_LK"
									:readonly="$route.name =='AHAM Investment'"
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-globe" size="20px" color="grey-4"/>
									</template>
								</q-select>
							</div>
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.mobileno")}}</b>
								<q-input 
								outlined
								v-model="StoreStateAOD.ContactInformation.MobileNo" 
								lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"  
								
								:readonly="$route.name =='AHAM Investment'"
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-mobile-alt" size="20px" color="grey-4"/>
									</template>
								</q-input>
							</div>

							
					</div>

					<div class="row">

							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.email")}}</b>
									<q-input 
									outlined
									v-model="StoreStateAOD.ContactInformation.EmailAddress" 
                  lazy-rules 
                  :rules="[val => !!val || '' + $t('common.fieldRequired') +' ', isValidEmail]"
									type="email"
									@keyup.enter="submit" 
									:readonly="$route.name =='AHAM Investment'"
									>
								<!-- 	:readonly="$route.name =='AHAM Investment'" -->
										<template v-slot:prepend>
											<q-icon name="fas fa-envelope-open-text" size="20px" color="grey-4"/>
										</template>
									</q-input>
							</div>

							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.nationality")}}</b>
								<q-select
									behavior="menu"
									outlined
									lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
									filter
									color="primary"
									v-model="StoreStateAOD.PersonalInformation.Nationality"
									:options="StoreStateLookup.Nationality_LK"
									:readonly="$route.name==='Application Details'"
								>
									<template v-slot:prepend>
										<q-icon name="far fa-flag" size="20px" color="grey-4"/>
									</template>
								</q-select>
							</div>
						
					</div>

					<div class="row">
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.countryofbirth")}}</b>
								<q-select
									outlined
									lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
									filter
									color="primary"
									behavior="menu"
									v-model="StoreStateAOD.PersonalInformation.CountryOfBirth"
									:options="StoreStateLookup.Country_LK"
									:readonly="$route.name==='Application Details'" 
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-globe-asia" size="20px" color="grey-4"/>
									</template>
								</q-select>
							</div>
					
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.epfno")}}</b>
								<q-input 
								outlined
								v-model="StoreStateAOD.PersonalInformation.EPFNumber" 
								:rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
								:readonly="$route.name =='AHAM Investment'"
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-user-circle" size="20px" color="grey-4"/>
									</template>
								</q-input>
							</div>
					</div>
					<div class="row">
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.epfaccount")}}</b>
								<q-input  
								outlined
								lazy-rules 
								:rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"  
								v-model="StoreStateAOD.PersonalInformation.EPFAccount" 
								:readonly="$route.name =='AHAM Investment'"
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-user-circle" size="20px" color="grey-4"/>
									</template>
								</q-input>
							</div>
						
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.shariahdate")}}</b>
								<q-input  
									outlined
									v-model="StoreStateAOD.PersonalInformation.EPFIEffectiveDate" 
									:readonly="$route.name =='AHAM Investment'" style="padding-bottom: 20px;">
									<template v-slot:prepend>
										<q-icon name="far fa-calendar-alt" size="20px" color="grey-4"/>
									</template>
								</q-input>
							</div>
							<!---lazy-rulesss :rules="[val => !!val || 'Field is required']"-->
					</div>

					<div class="row">
							

							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.household")}}</b>
								<q-input 
								outlined
								mask="#.##"
								fill-mask="0"
								reverse-fill-mask
								lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"  
								@blur="AmountBlurred()"  
								v-model="StoreStateAOD.MonthlyHouseholdIncome" 
															
								prefix="RM" 
								:suffix='$t("Applicant-Detail.suffix")'
								color="primary" 
								:readonly="$route.name==='Application Details'"
								>
									<template v-slot:prepend>
										<q-icon name="fas fa-wallet" size="20px" color="grey-4"/>
									</template>
								</q-input>
								<!-- v-if="AmountInputInvisible===false" <q-input filled lazy-rulesss :rules="[val => !!val || 'Field is required']" @focus="AmountFocused()" v-if="AmountInputInvisible===true" :value="StoreStateAOD.MonthlyHouseholdIncome | thousandSeparator" label="Monthly Household Income *" prefix="RM" suffix="monthly" color="primary" :readonly="$route.name==='Application Details'"/>-->
							</div>

						
					</div>
					
					<div class="row">
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.investmentpurpose")}}</b>
								
									<q-option-group 
										type="checkbox"
										color="teal-14"
										v-model="StoreStateAOD.PersonalInformation.InvestmentPurpose"
										:options="StoreStateLookup.InvestmentPurpose_LK"
										:readonly="$route.name==='Application Details'"
										class="d-option-group"
									/>
									<div class="col-md-3 offset-md-0" v-if="StoreStateAOD.PersonalInformation.InvestmentPurpose.includes('Others')">
										<b>{{$t("Applicant-Detail.investmentpurposeOther")}}</b>
											<q-input 
											outlined
											lazy-rules
											:rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
											v-model="StoreStateAOD.PersonalInformation.InvestmentPurposeOther" 
											
											:readonly="$route.name==='Application Details'"
											>
												<template v-slot:prepend>
													<!-- <q-icon name="far funnel-dollar" size="20px" color="grey-4"/> -->
												</template>
											</q-input>
									</div>

							</div>
							<div class="col-12 col-md-6">
								<b>{{$t("Applicant-Detail.sourceofwealth")}}</b>
								
								<q-option-group
									:rules="[val => !!val && StoreStateAOD.PersonalInformation.SourceOfWealth || '' + $t('common.fieldRequired') +' ']" 
									type="checkbox"
									color="teal-14"
									v-model="StoreStateAOD.PersonalInformation.SourceOfWealth"
									:options="StoreStateLookup.SourceOfWealth_LK"
									:readonly="$route.name==='Application Details'"
									class="d-option-group"
								/>
								<div class="" v-if="StoreStateAOD.PersonalInformation.SourceOfWealth.includes('Others')">

									<b>{{$t("Applicant-Detail.sourceofwealthOther")}}</b>
										<q-input 
										outlined
										lazy-rules 
										:rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
										v-model="StoreStateAOD.PersonalInformation.SourceOfWealthOther" 
										
										:readonly="$route.name==='Application Details'"
										>
											<template v-slot:prepend>
												<!-- <q-icon name="far money-bill-wave-alt" size="20px" color="grey-4"/> -->
											</template>
										</q-input>
								</div>

							</div>
					</div>
							  <div class="row">
						<!-- <div class="col-md-3 offset-md-0" v-if="StoreStateAOD.PersonalInformation.InvestmentPurpose.includes('Others')">
							{{$t("Applicant-Detail.others2")}}
								<q-input 
								outlined
								lazy-rules
								:rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
								v-model="StoreStateAOD.PersonalInformation.InvestmentPurposeOther" 
								
								:readonly="$route.name==='Application Details'"
								>
									<template v-slot:prepend>
										<q-icon name="far funnel-dollar" size="20px" color="grey-4"/>
									</template>
								</q-input>
						</div> -->
					
						<!-- <div class="" v-if="StoreStateAOD.PersonalInformation.SourceOfWealth.includes('Others')">
							{{$t("Applicant-Detail.others2")}}
								<q-input 
								outlined
								lazy-rules 
								:rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
								v-model="StoreStateAOD.PersonalInformation.SourceOfWealthOther" 
								
								:readonly="$route.name==='Application Details'"
								>
									<template v-slot:prepend>
										<q-icon name="far money-bill-wave-alt" size="20px" color="grey-4"/>
									</template>
								</q-input>
						</div> -->
					</div> 
					<div class="row">
						<div class="col-12 col-md-12">
        
        <div rounded class="">
				<b>{{$t("Fatca-Detail.declaration")}}</b>
				<!-- <q-field  :label='$t("Fatca-Detail.declaration")' readonly orientation="vertical"></q-field> -->
				<div class="q-py-sm" style="border: 1px solid #c2c2c2; border-radius: 0.5rem; margin-bottom: 20px;">
					<div class="row">
						<div class="col-12 q-pa-none" style="padding: 0px !important;">
							<q-item multiline class="q-pa-none" >
								
									<q-item-section avatar class="q-pa-none" style="padding-right: 0px;">
										<q-toggle
											color="green-14"
											v-model="StoreStateFATCA.PersonalAsset"
											:readonly="$route.name==='Application Details'"
										/>
									</q-item-section>
									<q-item-section class="q-pa-none">
										<q-item-label sublabel lines="20" style="color: black; line-height: 1.5em !important;">{{$t("Fatca-Detail.netpersonal") }}</q-item-label>
									</q-item-section>
								
								
							</q-item>
						</div>
					</div>
					<div class="row">
						<div class="col-12 q-pa-none" style="padding: 0px !important;">
							<q-item multiline class="q-pa-none">
								
									<q-item-section avatar style="padding-right: 0px;">
										<q-toggle
											color="green-14"
											v-model="StoreStateFATCA.SophisticatedInvestor"
											:readonly="$route.name==='Application Details'"
										/>
									</q-item-section>
								
									<q-item-section>
										<q-item-label sublabel lines="20" style="color: black; line-height: 1.5em !important;" class="">
											<span class="q-mr-sm">{{$t("Fatca-Detail.sophisticated.title")}}</span>
										
											<q-btn @click="sophisticatedInfo = !sophisticatedInfo" unelevated outline round size="xs" color="primary" icon="fas fa-info" class="" v-if="$route.name!=='Application Details'" style="font-size: 6px;"></q-btn>
												<q-dialog v-model="sophisticatedInfo">
													<q-card>
														<q-card-section class="row items-center q-pb-none">
															
															<q-btn icon="close" flat round dense v-close-popup style="    margin-left: auto;"/>
															<b style="padding: 0px 15px;">{{$t("Fatca-Detail.sophisticated.question")}}</b>		
														</q-card-section>

														<q-card-section>
													<q-list link separator class="scroll" style="min-width: 100px">
														<!-- <q-item overline>
															<b>{{$t("Fatca-Detail.sophisticated.question")}}</b>
														</q-item> -->
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">1.	 {{$t("Fatca-Detail.sophisticated.info1")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">2.	 {{$t("Fatca-Detail.sophisticated.info2")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">3.	 {{$t("Fatca-Detail.sophisticated.info3")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">4.	 {{$t("Fatca-Detail.sophisticated.info4")}}</q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">5.	 {{$t("Fatca-Detail.sophisticated.info5")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">6.	 {{$t("Fatca-Detail.sophisticated.info6")}}</q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">7.	 {{$t("Fatca-Detail.sophisticated.info7")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">8.	 {{$t("Fatca-Detail.sophisticated.info8")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">9.  {{$t("Fatca-Detail.sophisticated.info9")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">10.  {{$t("Fatca-Detail.sophisticated.info1")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">11.  {{$t("Fatca-Detail.sophisticated.info11")}}</q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">12.  {{$t("Fatca-Detail.sophisticated.info12")}}</q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">13.  {{$t("Fatca-Detail.sophisticated.info13")}}</q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">14.  {{$t("Fatca-Detail.sophisticated.info14")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">15.  {{$t("Fatca-Detail.sophisticated.info1")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">16.  {{$t("Fatca-Detail.sophisticated.info16")}}</q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">17.  {{$t("Fatca-Detail.sophisticated.info17")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">18.  {{$t("Fatca-Detail.sophisticated.info18")}} </q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">19.  {{$t("Fatca-Detail.sophisticated.info19")}}</q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">20.  {{$t("Fatca-Detail.sophisticated.info20")}}</q-item-section>
														</q-item>
														<q-item v-close-popup>
															<q-item-section sublabel lines="20" style="color:black;">21  {{$t("Fatca-Detail.sophisticated.info21")}} </q-item-section>
														</q-item>
													</q-list>
												</q-card-section>
												<q-card-actions align="right">
													<q-btn flat label="OK" color="primary" v-close-popup />
												</q-card-actions>
											</q-card>
										</q-dialog>
											
										</q-item-label>
									</q-item-section>
									
								
							</q-item>
						</div>
					</div>
					<div class="row">
						<div class="col-12" style="padding: 0px !important;">
							<q-item multiline class="q-pa-none">
								
									<q-item-section avatar style="padding-right: 0px;">
										<q-toggle
											color="green-14"
											v-model="StoreStateFATCA.PEP"
											:readonly="$route.name==='Application Details'"
										/>
									</q-item-section>
									<q-item-section>
										<q-item-label sublabel lines="20" style="color: black; line-height: 1.5em !important;">{{$t("Fatca-Detail.family")}}</q-item-label>
									</q-item-section>
								
							</q-item>
							
						</div>
					</div>
				</div>

				
        
        </div>
			</div>
					<!-- <div class="col-6">
						<q-item multiline tag="label">
							<q-item>
								<q-toggle v-model="StoreStateFATCA.PEP" :readonly="$route.name==='Application Details'" />
							</q-item>
								<q-item-section>
								<q-item-label sublabel lines="20" style="color:black;">{{$t("Fatca-Detail.family")}}
                                     
									<q-btn round size="xs" color="blue" icon="fas fa-info" class="" v-if="$route.name!=='Application Details'">
										<q-menu>
											<q-list link separator class="scroll" style="min-width: 100px">
												<q-list overline>
													<b>Politically Exposed Person means:</b>
												</q-list>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">1.	 A person who is or has been entrusted domestically or internationally with prominent public functions, for example Head of State or of government, senior politician, senior government, judicial or military official, senior executive of state owned corporation, important political party official; or</q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">2.	 A person who is or has been entrusted with a prominent function by an international organisation which refers to member of senior management, i.e. director, deputy director and member of the board or equivalent functions, and includes family members, i.e. parents, siblings, spouse, child and/or spouse's parents (both biological and non-biological, e.g. step parents/siblings or adopted parents/child).</q-item-section>
												</q-item>
											</q-list>
										</q-menu>
									</q-btn>
								</q-item-label>
								</q-item-section>
						</q-item>
					</div> 
						<div class="col-6">
						<q-list v-if="StoreStateFATCA.PEP===true" no-border>
							<div class="row">
								<div class="col-12">
									<q-input filled lazy-rulesss :rules="[val => !!val || 'Field is required']" v-model="StoreStateFATCA.PEPPosition" :label='$t("Fatca-Detail.pepposition")'  :readonly="$route.name==='Application Details'"/>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<q-input filled lazy-rulesss :rules="[val => !!val || 'Field is required']" v-model="StoreStateFATCA.PEPRelationship" :label='$t("Fatca-Detail.peprelationship")'  :readonly="$route.name==='Application Details'"/>
								</div>
							</div>
						</q-list>
					</div>-->
				</div>
				<q-list v-if="StoreStateFATCA.PEP===true" no-border>
					<div class="row">
						<div class="col-xs-12 col-md-6">
							<b>{{$t("Fatca-Detail.pepposition")}}</b>
							<q-input outlined lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" v-model="StoreStateFATCA.PEPPosition" :readonly="$route.name==='Application Details'"/>
						</div>
					
						<div class="col-xs-12 col-md-6">
							<b>{{$t("Fatca-Detail.peprelationship")}}</b>
							<q-input outlined lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" v-model="StoreStateFATCA.PEPRelationship" :readonly="$route.name==='Application Details'"/>
						</div>
					</div>
				</q-list>

			<div rounded class="">
				<!-- <q-field :label='$t("Applicant-Address.title")' readonly orientation="vertical"></q-field> -->
				<div class="row">
					<div class="col-12">
						<!-- {{$t("Applicant-Address.title")}} -->
						<b>{{$t("Applicant-Address.title")}}</b>
					</div>
						<div class="col-12 col-6">
							{{$t("Applicant-Address.add1")}}
							<q-input outlined v-model="StoreStateAOD.AddressInformation.PermanentAddress.Address1" lazy-rulesss :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" :readonly="$route.name==='Application Details'"/>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-6">
							{{$t("Applicant-Address.add2")}}
							<q-input outlined v-model="StoreStateAOD.AddressInformation.PermanentAddress.Address2" lazy-rulesss :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" :readonly="$route.name==='Application Details'"/>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-6">
							{{$t("Applicant-Address.add3")}}
							<q-input outlined v-model="StoreStateAOD.AddressInformation.PermanentAddress.Address3" style="padding-bottom: 20px;" :readonly="$route.name==='Application Details'"/>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12 col-md-6">
							{{$t("Applicant-Address.postcode")}}
							<q-select 
								behavior="menu"
								outlined
								@blur="selectedPostCode"
								lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"
								v-model="StoreStateAOD.AddressInformation.PermanentAddress.Postcode"
								use-input
								:options="postCodeList"
								@filter ="filterFn"
							>
							<template v-slot:no-option>
								<q-item>
								<q-item-section class="text-grey">
									No results
								</q-item-section>
								</q-item>
							</template>
							</q-select>
						</div>
					
				<!-- 	 <div class="row">
						<div class="col-12 col-6">
							<q-input @blur="PopulatePermanentAddressFromPostcode"  filled lazy-rulesss :rules="[val => !!val || 'Field is required']"  v-model="StoreStateAOD.AddressInformation.PermanentAddress.Postcode" label="Postcode *" :readonly="$route.name==='Application Details'"/>
						</div>
					</div> 

					<div class="row">
						<div class="col-12 col-6">
							<q-select
								filled
								v-model="StoreStateAOD.AddressInformation.PermanentAddress.Postcode"
								use-input
								input-debounce="0"
								label="PostCode"
								:options="options"
								@filter="filterFn"
								style="width: 250px"
								behavior="menu"
							>
								<template v-slot:no-option>
								<q-item>
									<q-item-section class="text-grey">
									No results
									</q-item-section>
								</q-item>
								</template>
							</q-select>
						</div>
					</div> -->

					
						<div class="col-xs-12 col-md-6">
							Town / City *
							<q-input outlined v-model="StoreStateAOD.AddressInformation.PermanentAddress.City" lazy-rulesss :rules="[val => !!val || 'Field is required']" :readonly="$route.name==='Application Details'"/>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-md-6">
							{{$t("Applicant-Address.country")}}
							<q-select
								outlined
								lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
								filter 
								color="primary"
								behavior="menu"
								v-model="StoreStateAOD.AddressInformation.PermanentAddress.Country"
								:options="StoreStateLookup.Country_LK"
								:readonly="$route.name==='Application Details'"
							/>
						</div>
						<div class="col-12 col-md-6">
							{{$t("Applicant-Address.state")}}
						<q-select 
							outlined
							v-if="StoreStateAOD.AddressInformation.PermanentAddress.Country.value ==='MY'|| StoreStateAOD.AddressInformation.PermanentAddress.Country ==='MALAYSIA'"
							lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"  
							v-model="StoreStateAOD.AddressInformation.PermanentAddress.State" 
							behavior="menu"
							:options="StoreStateLookup.State_LK"
							:readonly="$route.name==='Application Details'"/>

						<q-input 
						outlined 
						v-else-if="StoreStateAOD.AddressInformation.PermanentAddress.Country.value !=='MY'|| StoreStateAOD.AddressInformation.PermanentAddress.Country !=='MALAYSIA'"
						lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
						 v-model="StoreStateAOD.AddressInformation.PermanentAddress.StateForeign" 
						:label='$t("Applicant-Address.state")' 
					     :readonly="$route.name==='Application Details'"/>
						 </div>
					</div>
					<div class="row">
						
						<div class="col-12">
							<q-toggle
								color="green-14"
								@input="SetCorrespondenceAddress"
								v-model="StoreStateAOD.AddressInformation.SamePermanentAddress"
								:label='$t("Applicant-Address.sameaddress")'
								:readonly="$route.name==='Application Details'"
								style="margin-bottom: 20px;"
							/>
						</div>
					</div>

					<div v-if="StoreStateAOD.AddressInformation.SamePermanentAddress===false">
						<!-- <q-field :label='$t("Applicant-Address.title2")' readonly orientation="vertical"></q-field> -->
						
						<div class="row">
							<div class="col-12">
								<!-- {{$t("Applicant-Address.title2")}} -->
								<b>{{$t("Applicant-Address.title2")}}</b>
							</div>
							<div class="col-12 col-6">
								{{$t("Applicant-Address.add1")}}
								<q-input outlined lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"  v-model="StoreStateAOD.AddressInformation.CorrespondenceAddress.Address1" :readonly="$route.name==='Application Details'"/>
							</div>
						</div>
						<div class="row">
							<div class="col-12 col-6">
								{{$t("Applicant-Address.add2")}}
								<q-input outlined lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"  v-model="StoreStateAOD.AddressInformation.CorrespondenceAddress.Address2" :readonly="$route.name==='Application Details'"/>
							</div>
						</div>
						<div class="row">
							<div class="col-12 col-6">
								{{$t("Applicant-Address.add3")}}
								<q-input outlined v-model="StoreStateAOD.AddressInformation.CorrespondenceAddress.Address3" :readonly="$route.name==='Application Details'" style="padding-bottom: 20px;"/>
							</div>
						</div>
						<!-- <div class="row">
							<div class="col-12 col-6">
								<q-input filled lazy-rulesss :rules="[val => !!val || 'Field is required']"  @blur="PopulateCorrespondenceAddressFromPostcode" v-model="StoreStateAOD.AddressInformation.CorrespondenceAddress.Postcode" label="Postcode *" :readonly="$route.name==='Application Details'"/>
							</div>
						</div> -->

						<div class="row">
							<div class="col-xs-12 col-md-6">
								{{$t("Applicant-Address.postcode")}}
								<q-select 
									behavior="menu"
									outlined
									lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"
									@blur="selectedCorrespondencePostCode"
									v-model="StoreStateAOD.AddressInformation.CorrespondenceAddress.Postcode"
									use-input
									:options="postCodeList"
									@filter ="filterFn"
								>
								<template v-slot:no-option>
									<q-item>
									<q-item-section class="text-grey">
										No results
									</q-item-section>
									</q-item>
								</template>
								</q-select>
							</div>
						
							<div class="col-xs-12 col-md-6">
								{{$t("Applicant-Address.city")}}
								<q-input outlined lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"   v-model="StoreStateAOD.AddressInformation.CorrespondenceAddress.City" :readonly="$route.name==='Application Details'"/>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12 col-md-6">
								{{$t("Applicant-Address.country")}}
								<q-select
									outlined
									lazy-rules :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" 
									filter
									color="primary"
									behavior="menu"
									v-model="StoreStateAOD.AddressInformation.CorrespondenceAddress.Country"
									:options="StoreStateLookup.Country_LK"
										:readonly="$route.name==='Application Details'"
								/>
							</div>
							<div class="col-xs-12 col-md-6">
								{{$t("Applicant-Address.state")}}
								<q-select
									outlined 
									lazy-rules :rules="[val => !!val ||'' + $t('common.fieldRequired') +' ']" 
									filter
									v-if="StoreStateAOD.AddressInformation.CorrespondenceAddress.Country.value==='MY'||StoreStateAOD.AddressInformation.CorrespondenceAddress.Country==='MALAYSIA'"
									color="primary"
									behavior="menu"
									v-model="StoreStateAOD.AddressInformation.CorrespondenceAddress.State"
									:options="StoreStateLookup.State_LK"
									:readonly="$route.name==='Application Details'"
								/>
								
								<q-input outlined lazy-rules 
								:rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"  
								v-else-if="StoreStateAOD.AddressInformation.CorrespondenceAddress.Country.value !== 'MY' || StoreStateAOD.AddressInformation.CorrespondenceAddress.Country != 'MALAYSIA'" 
								v-model="StoreStateAOD.AddressInformation.CorrespondenceAddress.StateForeign" :readonly="$route.name==='Application Details'" />
							</div>
						</div>	
					</div>	
				</div>
			</div>
		<!-- <br class="mobile-only"> -->
		</div>
	</div>
    </div>
</template>

<style lang="stylus" scoped>
.row > div {
  padding: 10px 15px
}
</style>
<style >
/* Style Customization by Desmond */
/* .q-field--with-bottom {
    padding-bottom: 10px !important;
} */

.q-field__control.relative-position.row.no-wrap {
    border-radius: 0.5rem !important;
}

.q-toggle__thumb.absolute.flex.flex-center.no-wrap {
    color: #fff !important;
    border: 1px solid #f5f5f5 !important;
    border-radius: 100% !important;
}

.q-field__bottom.row.items-start.q-field__bottom--animated {
    padding-left: 0px !important;
}

.q-field__messages {
    text-align: left !important;
}
.q-field__messages.col {
	text-align: left !important;
}

.d-option-group{
	border-radius: 0.5rem !important; border: 1px solid rgba(0, 0, 0, 0.24); margin-bottom: 20px; 
	margin-left: 0px !important; margin-right: 0px !important; 
	padding: 0.75rem 0.5rem; 
}


@media screen and (min-width: 1024px) {
	.d-option-group{
		height: 306px !important;
	}
}
/* Fix select options layout */
/* .q-item.q-item-type.row.no-wrap.q-item--clickable.q-link.cursor-pointer.q-manual-focusable {
    margin: 0px 16px;
} */

.d-btn-toggle{
	border: 1px solid rgb(194 194 194); padding: 5px; margin-bottom: 20px; border-radius: 0.5rem !important; height: 56px; width: 100%;
}
.q-btn-group.row.no-wrap.inline.q-btn-toggle.q-btn-group--unelevated button {
    width: -webkit-fill-available;
}

.q-stepper__nav.float-right.q-pa-md {
    margin-right: 8px !important;
}
</style>

<script>

import {VMoney} from 'v-money'
import store from '../store';
export default {
    name: 'ApplicantDetails',
	data () {
		return {
			sophisticatedInfo: false,
      		StoreStateFATCA : store.state.FATCA,
			AmountInputInvisible : true,
			StoreStateAD : store.state.AD, 
			StoreStateAOD : store.state.AOD,           
			StoreStateLookup : store.state.Lookup,
			StoreStateAPI : store.state.API,
			options:[],
			money: {
                decimal: '.',
                thousands: ',',
                precision: 2,
                masked: false /* doesn't work with directive */
			},
        }
	},	
    directives: {money: VMoney},
	mounted () {
		
  	},
  	computed: {
		postCodeList : function(){
            return this.StoreStateAPI.PostCodeList
        },
        isValidUserID () {
            
            if(this.StoreStateAD.userID.length <= 10){
                this.StoreStateAD.SubmitApplicantCredential= true;
            }else{
                this.StoreStateAD.SubmitApplicantCredential= false;
            }
            return this.StoreStateAD.userID.length <= 10
        },
        ConfirmPWD() {
            
           
          if((v) => !!v ){
                this.StoreStateAD.SubmitApplicantCredential= true;
          }else{
                this.StoreStateAD.SubmitApplicantCredential= false;
          }
            return [
                (v) => !!v || "*Required",
                (v) => v == this.$refs.fldPasswordChange.value || "Password does not match!"
                ]
        },
        PasswordRequired() {            
            if((v) => !!v ){
                this.StoreStateAD.SubmitApplicantCredential= true;
            }else{                
                this.StoreStateAD.SubmitApplicantCredential= false
            }
            return [(v) => !!v || '*Required']
        }


    },methods:{
		selectedPostCode:function (value){
			var checking = false
			var selectedPostCodeValue = value.label;
			var selectedState
			if(checking == false){
				checking = true
				for(var i=0; i<this.StoreStateAOD.OnboardAddressPopulate.length ; i++){
					if(selectedPostCodeValue != undefined){
						if(selectedPostCodeValue === this.StoreStateAOD.OnboardAddressPopulate[i].PostCode ){
							
							this.StoreStateAOD.AddressInformation.PermanentAddress.City = this.StoreStateAOD.OnboardAddressPopulate[i].City
							selectedState = this.StoreStateAOD.OnboardAddressPopulate[i].State
							for(var j=0; j<this.StoreStateLookup.State_LK.length;j++){
 								if(selectedState===this.StoreStateLookup.State_LK[j].EMISValue){

									this.StoreStateAOD.AddressInformation.PermanentAddress.State = this.StoreStateLookup.State_LK[j].label
								}
							}
						}
					}else if(this.StoreStateAOD.AddressInformation.PermanentAddress.Postcode.label !=undefined){
							//console.log("--> " + this.StoreStateAOD.AddressInformation.PermanentAddress.Postcode.label)
						if(this.StoreStateAOD.AddressInformation.PermanentAddress.Postcode.label === this.StoreStateAOD.OnboardAddressPopulate[i].PostCode ){
							//console.log(this.StoreStateAOD.AddressInformation.PermanentAddress.Postcode.label)
							this.StoreStateAOD.AddressInformation.PermanentAddress.City = this.StoreStateAOD.OnboardAddressPopulate[i].City
							selectedState = this.StoreStateAOD.OnboardAddressPopulate[i].State
							for(var j=0; j<this.StoreStateLookup.State_LK.length;j++){
								if(selectedState===this.StoreStateLookup.State_LK[j].EMISValue){
									this.StoreStateAOD.AddressInformation.PermanentAddress.State = this.StoreStateLookup.State_LK[j].label
								}
							}
						}
					}else{
						//console.log("--> " + this.StoreStateAOD.AddressInformation.PermanentAddress.Postcode)
						if(this.StoreStateAOD.AddressInformation.PermanentAddress.Postcode === this.StoreStateAOD.OnboardAddressPopulate[i].PostCode ){
						//	console.log(this.StoreStateAOD.AddressInformation.PermanentAddress.Postcode)
							this.StoreStateAOD.AddressInformation.PermanentAddress.City = this.StoreStateAOD.OnboardAddressPopulate[i].City
							selectedState = this.StoreStateAOD.OnboardAddressPopulate[i].State
							for(var j=0; j<this.StoreStateLookup.State_LK.length;j++){
								if(selectedState===this.StoreStateLookup.State_LK[j].EMISValue){
									this.StoreStateAOD.AddressInformation.PermanentAddress.State = this.StoreStateLookup.State_LK[j].label
								}
							}
						}
					}
					
				}	
			}
			checking = false;
		},
		selectedCorrespondencePostCode:function (value){
			var checking = false
			var selectedPostCodeValue = value.label;
			var selectedState
			if(checking == false){
				checking = true
				for(var i=0; i<this.StoreStateAOD.OnboardAddressPopulate.length ; i++){
					if(selectedPostCodeValue != undefined){
						if(selectedPostCodeValue === this.StoreStateAOD.OnboardAddressPopulate[i].PostCode ){
							this.StoreStateAOD.AddressInformation.CorrespondenceAddress.City = this.StoreStateAOD.OnboardAddressPopulate[i].City
			
							this.StoreStateAOD.AddressInformation.CorrespondenceAddress.Country='MALAYSIA'
							selectedState = this.StoreStateAOD.OnboardAddressPopulate[i].State
							for(var j=0; j<this.StoreStateLookup.State_LK.length;j++){
								if(selectedState===this.StoreStateLookup.State_LK[j].EMISValue){
									this.StoreStateAOD.AddressInformation.CorrespondenceAddress.State = this.StoreStateLookup.State_LK[j].label
								}
							}
						}
					}else if(this.StoreStateAOD.AddressInformation.CorrespondenceAddress.Postcode.label != undefined){
						//console.log(this.StoreStateAOD.AddressInformation.CorrespondenceAddress.Postcode.label)
						if(this.StoreStateAOD.AddressInformation.CorrespondenceAddress.Postcode.label === this.StoreStateAOD.OnboardAddressPopulate[i].PostCode ){
							this.StoreStateAOD.AddressInformation.CorrespondenceAddress.City = this.StoreStateAOD.OnboardAddressPopulate[i].City
			
							this.StoreStateAOD.AddressInformation.CorrespondenceAddress.Country='MALAYSIA'
							selectedState = this.StoreStateAOD.OnboardAddressPopulate[i].State
							for(var j=0; j<this.StoreStateLookup.State_LK.length;j++){
								if(selectedState===this.StoreStateLookup.State_LK[j].EMISValue){
									this.StoreStateAOD.AddressInformation.CorrespondenceAddress.State = this.StoreStateLookup.State_LK[j].label
								}
							}
						}
					}else{
						if(this.StoreStateAOD.AddressInformation.CorrespondenceAddress.Postcode === this.StoreStateAOD.OnboardAddressPopulate[i].PostCode ){
							this.StoreStateAOD.AddressInformation.CorrespondenceAddress.City = this.StoreStateAOD.OnboardAddressPopulate[i].City
			
							this.StoreStateAOD.AddressInformation.CorrespondenceAddress.Country='MALAYSIA'
							selectedState = this.StoreStateAOD.OnboardAddressPopulate[i].State
							for(var j=0; j<this.StoreStateLookup.State_LK.length;j++){
								if(selectedState===this.StoreStateLookup.State_LK[j].EMISValue){
									this.StoreStateAOD.AddressInformation.CorrespondenceAddress.State = this.StoreStateLookup.State_LK[j].label
								}
							}
						}
					}
				}
			}
			checking = false;
			
		},
		 filterFn:function (val, update, abort) {    
			 /* if (val === '') {
					update(() => {
						this.StoreStateLookup.EmisPostCode = this.StoreStateLookup.EmisPostCodeTemp
						//this.$store.dispatch('UpdatePostCodeList') 
					})
					return
				} */
            update(() => {
                const needle = val.toLowerCase();
				this.$store.dispatch('UpdatePostCodeList',this.StoreStateLookup.EmisPostCode.filter(v => v.value.toLowerCase().indexOf(needle) > -1))
			})
		},
		
		comparePwd: function(){

			if(this.$refs.fldPasswordChangeConfirm.value == this.$refs.fldPasswordChange.value){

					this.StoreStateAD.SamePassword= true;
			}else{ 
					this.StoreStateAD.SamePassword= false;
			}
		},
    AmountFocused(){
			this.AmountInputInvisible = false;
		},
		AmountBlurred(){
			this.AmountInputInvisible = true;
		},

		PopulateHolderStatus : function(){
			
		var Race = this.StoreStateAOD.PersonalInformation.Race.value;
		store.commit('SET_StatusByRace', Race);
		},
		PopulatePermanentAddressFromPostcode: function(){
			var postcode = this.StoreStateAOD.AddressInformation.PermanentAddress.Postcode;
			this.$store.dispatch('SetPermanentAddressByPostcode', postcode);
		},
		PopulateCorrespondenceAddressFromPostcode: function(){
			var postcode = this.StoreStateAOD.AddressInformation.CorrespondenceAddress.Postcode;
			this.$store.dispatch('SetCorrespondenceAddressByPostcode', postcode);
		},
		
		SetCorrespondenceAddress: function(){
			store.commit('SET_CorrespondenceAddresByPermanentAddress');
		},
    isValidEmail (val) {
      const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      return emailPattern.test(val) || 'Invalid email';
    },
	},
	filters: {
		thousandSeparator: function(value) {
			if (value !== undefined) {
				return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			} else {
				return value;
			}
		}
  }
  
}
</script>